// import injector from 'vue-inject'
import * as types from './mutation-types'
import shortid from 'shortid'

export default {
  // TODO: 把 addItemToFavorites 跟 addNewItemToCart 還有 addFavoriteItemToCart 結合成一個
  addItemToFavorites ({ state, commit }, itemObj) {
    commit(types.SET_ITEM, {
      isNew: false,
      itemObj: {
        itemBucket: 'favorites',
        id: itemObj.id,
        instanceId: new Date().getTime().toString(),
        values: Object.assign({}, itemObj.values),
        specialRequests: itemObj.specialRequests
      }
    })
  },
  addNewItemToCart ({ commit }, id) {
    // const newInstanceId = injector.get('IdGenerator').generate(`item-${id}`)
    commit(types.SET_ITEM, {
      isNew: true,
      itemObj: {
        itemBucket: 'cart',
        id,
        instanceId: shortid.generate(),
        values: {}
      }
    })
  },
  addFavoriteItemToCart ({ commit }, obj) {
    // const newInstanceId = injector.get('IdGenerator').generate(`item-${obj.id}`)
    commit(types.SET_ITEM, {
      isNew: true,
      itemObj: {
        itemBucket: 'cart',
        id: obj.id,
        instanceId: shortid.generate(),
        values: Object.assign({}, obj.values),
        specialRequests: obj.specialRequests
      }
    })
  },
  setQuestion ({ commit }, param) {
    commit(types.SET_QUESTION, param)
  },
  setSpecialRequests ({ commit }, param) {
    commit(types.SET_SPECIAL_REQUESTS, param)
  },
  removeItem ({ commit }, param) {
    commit(types.REMOVE_ITEM, param)
  },
  setCartItems ({ commit }, items) {
    Object.keys(items).forEach(k => {
      commit(types.SET_ITEM, {
        isNew: false,
        itemObj: {
          itemBucket: 'cart',
          id: items[k].id,
          instanceId: shortid.generate(),
          values: Object.assign({}, items[k].values),
          specialRequests: items[k].specialRequests
        }
      })
    })
  },
  resetBucket ({ commit }, param) {
    commit(types.RESET_BUCKET, param)
  },
  resetAllBuckets ({ commit }) {
    commit(types.RESET_ALL_BUCKETS)
  }
}
